<template>
  <div class="remote_my_monitor_area"
       :class="audioVideoProps && cameraProps && deviceListProps.cameraList.length > 0? '' : 'hidden'">
    <div class="remote_my_monitor_header"
         :class="realTimeAttendeesProps.length > 1 && tileCountProps > 1? '' : 'hidden'">
      <div class="remote_btn_change" @click="clickVideoSwitch">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             width="24" height="24"
             viewBox="0 0 172 172"
             style=" fill:#000000;">
          <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
             stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
             font-family="none" font-weight="none" font-size="none" text-anchor="none"
             style="mix-blend-mode: normal">
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#ffffff">
              <path
                  d="M114.66667,107.5h57.33333l-28.66667,35.83333zM57.33333,64.5h-57.33333l28.66667,-35.83333z"></path>
              <path
                  d="M150.5,43c0,-11.85367 -9.64633,-21.5 -21.5,-21.5h-77.6795l11.46667,14.33333h66.21283c3.94883,0 7.16667,3.21067 7.16667,7.16667v71.66667h14.33333zM21.5,129c0,11.85367 9.64633,21.5 21.5,21.5h77.6795l-11.46667,-14.33333h-66.21283c-3.94883,0 -7.16667,-3.21067 -7.16667,-7.16667v-71.66667h-14.33333z"></path>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="view"
         :class="realTimeAttendeesProps.length > 1 && tileCountProps > 1? '' : ''"
         style="display: none;"
    >
      <div class="remote_btn_change" style="bottom: 10px; right: 10px;" @click="handleVisible">
        <svg v-if="visible" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.3 3.29a.995.995 0 0 1 1.409 0l15.994 16.007c.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29-.26 0-.51-.09-.71-.29l-2.669-2.67c-.08.08-.16.15-.27.2-1.379.66-2.838 1-4.348 1-4.158 0-7.957-2.621-9.906-6.823-.12-.27-.12-.57 0-.84.84-1.811 2.07-3.372 3.539-4.542L3.299 4.7a.997.997 0 0 1 0-1.41zm9.306 10.725-2.619-2.622c-.06.2-.1.4-.11.6 0 1.171.95 2.122 2.12 2.122.21 0 .41-.04.609-.1zm-8.487-2.011c1.67 3.251 4.648 5.242 7.887 5.242 1.08 0 2.14-.24 3.15-.66l-1.08-1.08c-.07.08-.15.15-.25.2-.57.28-1.2.43-1.83.43a4.127 4.127 0 0 1-4.118-4.122c0-.64.15-1.26.43-1.831a.86.86 0 0 1 .2-.26l-1.48-1.48c-.015.014-.027.032-.04.05-.012.017-.025.034-.04.05-1.15.89-2.12 2.08-2.829 3.46zm7.877-7.234c4.159 0 7.957 2.611 9.906 6.813.13.27.13.57 0 .85-.54 1.14-1.219 2.191-2.029 3.111-.2.23-.47.34-.75.34a.99.99 0 0 1-.66-.25.99.99 0 0 1-.09-1.41c.58-.66 1.08-1.4 1.5-2.211-1.67-3.251-4.648-5.242-7.887-5.242-.53 0-1.07.05-1.59.16a1.002 1.002 0 0 1-.399-1.96c.66-.131 1.33-.201 2-.201z" fill="#fff"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.996 5c4.159 0 7.957 2.525 9.906 6.589.13.261.13.551 0 .813C19.953 16.474 16.155 19 11.996 19c-4.158 0-7.957-2.535-9.906-6.598a.963.963 0 0 1 0-.813C4.04 7.525 7.838 5 11.996 5zM4.12 11.995c1.67 3.145 4.648 5.07 7.887 5.07 3.229 0 6.218-1.935 7.887-5.07-1.67-3.144-4.648-5.07-7.887-5.07S5.79 8.86 4.12 11.995zm3.769 0c0-2.196 1.85-3.986 4.118-3.986 2.27 0 4.109 1.79 4.119 3.986 0 2.196-1.85 3.986-4.119 3.986-2.269 0-4.118-1.79-4.118-3.986zm1.999 0c0 1.132.95 2.051 2.12 2.051 1.159 0 2.108-.919 2.118-2.05 0-1.133-.95-2.052-2.119-2.052-1.17 0-2.119.92-2.119 2.051z" fill="#fff"/>
        </svg>
      </div>
    </div>
    <video
        id="myVideo"
        :class="audioVideoProps && cameraProps && deviceListProps.cameraList.length > 0? '' : 'hidden'"
        ref="myVideo"
        width="100%"
        style="min-width: 300px; max-width: 300px; height: 225px;"
        :style="visible === true ? '' : 'display:none;'"
    />
  </div>
</template>
<script>
export default {
  name: 'myMonitorArea',
  props: ['audioVideoProps', 'cameraProps', 'deviceListProps', 'realTimeAttendeesProps', 'tileCountProps'],
  data() {
    return {
      visible: true,
      reverse: true,
    }
  },
  methods: {
    clickVideoSwitch() {
      this.$emit('clickVideoSwitch');
    },
    handleVideoClick() {
      this.reverse = !this.reverse
    },
    handleVisible() {
      this.visible = !this.visible
    }
  }
}
</script>